import React, { useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom'; 


const ReloadWallet = ({ document, celular, onPaymentSuccess }) => {
  const [formData, setFormData] = useState({
    document,
    celular,
    valor: ''
  });
  const [message, setMessage] = useState('');

  // const navigate = useNavigate(); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/user/reload-wallet`, formData);
      setMessage(response.data.message);
      onPaymentSuccess(); // Llama a la función para actualizar el balance
    } catch (error) {
      setMessage(error.response ? error.response.data.message : 'Ocurrió un error al cargar saldo.');
    }
  };

  // const handleBack = () => {
  //   setMessage('');
  //   setFormData({
  //     document: '',
  //     nombres: '',
  //     email: '',
  //     celular: ''
  //   });
  //   navigate('/'); // Redirigir a la página principal
  // };

  return (
    <Container>
      <FormContainer>
        <Text>Cargar Saldo en Billetera</Text>
        <Row>
          <Column>
            <InputContainer>
              <Label>Documento de Identidad:</Label>
              <Input
                type="text"
                name="document"
                value={formData.document}
                onChange={handleChange}
                placeholder="Número de documento"
                required
              />
            </InputContainer>
            <InputContainer>
              <Label>Celular:</Label>
              <Input
                type="tel"
                name="celular"
                value={formData.celular}
                onChange={handleChange}
                placeholder="Número de teléfono"
                required
              />
            </InputContainer>
          </Column>
          <Column>
            <InputContainer>
              <Label>Monto:</Label>
              <Input
                type="number"
                name="valor"
                value={formData.valor}
                onChange={handleChange}
                placeholder="0.00"
                required
              />
            </InputContainer>
          </Column>
        </Row>
        <ButtonContainer>
          {/* <Button onClick={handleBack} style={{marginRight: '10px'}}>Regresar</Button> */}
          <Button type="submit" onClick={handleSubmit}>Cargar Saldo</Button>
        </ButtonContainer>
        {message && <p style={{color: message.startsWith('Error') ? 'red' : 'green'}}>{message}</p>}
      </FormContainer>
    </Container>
  );
};

// Estilos con styled-components
const Container = styled.div`
  display: flex;
  justify-content: flex-start; // Cambia esto de 'center' a 'flex-start'
  align-items: center;
  //min-height: 100vh;
  margin-left: 200px; // Añade un padding a la izquierda
  width: 90%; // Añadimos width: 100%
`;

const Text = styled.h2`
  margin-top: 20px; // Aumentamos el margen superior
  margin-bottom: 50px; // Añadimos un margen inferior
  text-align: center; // Centramos el texto
`;

const FormContainer = styled.div`
  color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background: linear-gradient(to bottom right, #333, #555);
  width: 100%; // Añadimos width: 100%
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: calc(50% - 20px);
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

const Label = styled.label`
  margin-right: 10px;
  font-weight: bold;
  min-width: 120px; // Ajusta este valor según el ancho que desees para los labels
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap; // Añadimos flex-wrap: wrap para que los elementos se ajusten en dispositivos pequeños
  gap: 20px;
`;


const Input = styled.input`
flex-grow: 1; // Añade este para que los inputs ocupen el espacio restante
  display: block;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const Button = styled.button`
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

export default ReloadWallet;
